var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/chevron_left") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/chevron_left",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.423834,5.5198617 C13.6890071,5.20165403 14.1619306,5.15866098 14.4801383,5.42383404 C14.769418,5.66490046 14.8312476,6.07766148 14.6408702,6.38979079 L14.576166,6.4801383 L9.976,12 L14.576166,17.5198617 C14.8172324,17.8091414 14.8036161,18.2262854 14.560074,18.4989675 L14.4801383,18.576166 C14.1908586,18.8172324 13.7737146,18.8036161 13.5010325,18.560074 L13.423834,18.4801383 L8.42383404,12.4801383 C8.21780851,12.2329077 8.19491679,11.8862217 8.35515886,11.6168898 L8.42383404,11.5198617 L13.423834,5.5198617 Z",
    id: "Stroke-3-Copy",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.7ef3bae5.svg";
export { ForwardRef as ReactComponent };